import { type ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface FilterSheetProps {
  onClose: () => void;
  children: ReactNode;
}

export function FilterSheet({ onClose, children }: FilterSheetProps) {
  const { t } = useTranslation();

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="sheet-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet__grip" />
        <div style={{ display: 'grid', gap: 'var(--sp-4)', paddingBlockEnd: 'var(--sp-2)' }}>
          {children}
        </div>
        <button type="button" className="sheet__cancel" onClick={onClose}>
          {t('common.close')}
        </button>
      </div>
    </div>
  );
}
